import { useDispatch } from "react-redux";
import { customApi } from "../../../../CustomHoock/CustomApi";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { getOrderTotalR } from "../../../../General/Store/GeneralSlice";

const useGetAllAnnouncementWithTotal = (reqUnitsBody) => {
  const dispatch = useDispatch();
  let totalRecord;
  return useQuery(
    ["announcement", reqUnitsBody],
    () =>
      customApi({
        apiType: "post",
        url: "/api/v1/Announcement/GetAllAnnouncementWithTotal",
        requestBody: reqUnitsBody,
        reactQuery: "query",
      }),
    {
      enabled: !!reqUnitsBody,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        dispatch(getOrderTotalR(totalRecord));
        return data;
      },
      onError: () => {},
      select: (data) => {
        totalRecord = data?.data.totalRecord; //for pagnation
        let PersonBankInfo = data?.data.data;
        return PersonBankInfo;
      },
    }
  );
};
const useGetAllPerson = () => {
  return useMutation(
    (unitId) =>
      customApi({
        apiType: "get",
        url: `/api/v1/Announcement/GetAllPerson?unitId=${unitId}`,
        reactQuery: "mutate",
      }),
    {
      onSuccess: (data) => {
        return data;
      },
    }
  );
};



const useGetAllAnnouncement = (userId) => {
  return useQuery(
    ["GetAllAnnouncement", userId], 
    () =>
      customApi({
        apiType: "get",
        url: `/api/v1/Announcement/GetAllAnnouncement?userId=${userId}`,
        reactQuery: "query",
      }),
    {
      enabled: !!userId, 

      refetchInterval:  300000, 

      // وقتی مرورگر در background است polling متوقف شود
      refetchIntervalInBackground: false,
      refetchOnWindowFocus: false,
      onSuccess: (data) => {
        return data;
      },

      onError: (error) => {
        console.error("خطا در دریافت اعلان‌ها:", error);
      },
      select: (response) => response?.data?.data || [],
    }
  );
};

const useAddAnnouncement = (handleSuccess, handleFailed) => {
  const queryClient = useQueryClient();
  return useMutation(
    (body) =>
      customApi({
        apiType: "post",
        url: "/api/v1/Announcement/AddAnnouncement",
        reactQuery: "mutate",
        requestBody: body,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("announcement");
        if (handleSuccess) handleSuccess();
      },
      onError: () => {
        if (handleFailed) handleFailed();
      },
    }
  );
};
const useUpdateAnnouncement = (handleSuccess, handleFailed) => {
  const queryClient = useQueryClient();
  return useMutation(
    (body) =>
      customApi({
        apiType: "post",
        url: "/api/v1/Announcement/UpdateAnnouncement",
        reactQuery: "mutate",
        requestBody: body,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("announcement");
        if (handleSuccess) handleSuccess();
      },
      onError: () => {
        if (handleFailed) handleFailed();
      },
    }
  );
};
const useDeleteAnnouncement = (handleSuccess, handleFailed) => {
  const queryClient = useQueryClient();
  return useMutation(
    (body) =>
      customApi({
        apiType: "delete",
        url: "/api/v1/Announcement/DeleteAnnouncement",
        queryparameters: "announcementId",
        reactQuery: "mutate",
        requestBody: body,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries("announcement");
        handleSuccess();
      },
      onError: () => {
        handleFailed();
      },
    }
  );
};
export {
  useGetAllAnnouncementWithTotal,
  useGetAllPerson,
  useAddAnnouncement,
  useDeleteAnnouncement,
  useUpdateAnnouncement,
  useGetAllAnnouncement
};
